// src/services/calendarService.js
import api from './api';

const calendarService = {
  getGoogleStatus: async () => {
    const response = await api.get('/calendar/google/status');
    return response.data;
  },

  getGoogleAuthUrl: async () => {
    const response = await api.get('/calendar/google/auth-url');
    return response.data;
  },

  disconnectGoogle: async () => {
    const response = await api.delete('/calendar/google/connection');
    return response.data;
  },

  // Obtener todos los eventos
  getEvents: async () => {
    const response = await api.get('/calendar/events');
    return response.data;
  },

  // Crear un nuevo evento
  createEvent: async (eventData) => {
    const response = await api.post('/calendar/events', eventData);
    return response.data;
  },

  // Eliminar un evento
  deleteEvent: async (id) => {
    const response = await api.delete(`/calendar/events/${id}`);
    return response.data;
  }
};

export default calendarService;
